import { getQueryKeys } from "../../helper";

const namespace = "users";

export default {
  ...getQueryKeys(namespace),
};
